import React from 'react';
import styles from './starInstruction.module.scss';
import LStarInstruction from '../../../components/lStarInstruction/lStarInstruction';
class StarInstruction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }
  componentDidMount() {
    // console.log(this.props.location, 'this.props')
  }


  backHome = () => {
    console.log('backHome')
    this.props.showDynamic({
      starListShow: false,
      starInstructionShow: false
    })
  }

  render() {
    return (
      <div className={styles.starInstruct}>
        <header className={styles.header}>
          <div className={styles.title} onClick={() => this.backHome()}>
            <p>星星规则</p>
            <i></i>
          </div>
        </header>
        <LStarInstruction />
      </div>
    )
  }
}
export default StarInstruction;